import { useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { trackEvent, identifyUser } from '@offerzen/pinata'

import { useParseResume } from '../../../CandidateExperience/hooks'
import { updateCandidate as reduxUpdateCandidate } from '../../redux/modules/candidate'
import { updateProgress as reduxUpdateProgress } from '../../redux/modules/utility'
import { loadingCandidate } from '../../selectors/currentUser'
import { nextOnboardingUrl } from '../../helpers/onboardingSteps'

const ResumeContainer = ({ children, updateProgress, ...rest }) => {
  useEffect(() => {
    identifyUser(rest.candidate.user_id)
    trackEvent('onboarding-area-cv-parse-accessed')
    updateProgress(0)
    // updateProgress causes infinite renders due to a change in Redux state.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rest.candidate.user_id])

  const {
    importResume,
    isParsingResume,
    resumeParsingExecution,
    resumeParsingExecutionStatus,
    hasPolledTooManyTimes,
    reset: resetResumeParser,
  } = useParseResume(rest.candidate.id, 'onboarding')

  return children({
    ...rest,
    importResume,
    isParsingResume,
    hasPolledTooManyTimes,
    resumeParsingExecutionStatus,
    resumeParsingExecution: resumeParsingExecution && resumeParsingExecution.candidateProfile.resumeParsingExecution,
    resetResumeParser,
    trackSelectedFile: () =>
      trackEvent('Candidate: profile action', {
        action: 'selected cv parse',
        source: 'onboarding',
      }),
  })
}

const mapStateToProps = state => ({
  candidate: state.candidate,
  loadingCandidate: loadingCandidate(state),
})

const mapDispatchToProps = dispatch => ({
  updateCandidate: nextUrl => dispatch(reduxUpdateCandidate({ onboarding_phase: 'ideal_job' }, nextUrl)),
  updateProgress: progress => dispatch(reduxUpdateProgress(progress)),
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  updateCandidate: () => {
    dispatchProps.updateCandidate(nextOnboardingUrl(ownProps.location.pathname))
  },
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(ResumeContainer))
